import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Navigation } from './components/Navigation';
import { Home } from './pages/Home';
import { FormFlow } from './pages/FormFlow';
import { Dashboard } from './components/dashboard/Dashboard';

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-[#0a1229] text-white font-sans">
        <Navigation />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/form" element={<FormFlow />} />
          <Route path="/dashboard" element={<Dashboard />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App